class ValidationService {
  private regEx: Array<RegExp> = [
    /(?=.*[A-Z])/,
    /(?=.*[a-z])/,
    /(?=.*[0-9])/,
    /(?=.*[\W])/,
  ];

  private pass = '';

  numberValidation(value: string): boolean {
    return /^\d+$/.test(value);
  }

  emailValidation(value: string): boolean {
    if (
      value.match(/^([a-zA-Z0-9._%-+\w-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/) &&
      value.length < 64
    ) {
      return true;
    }
    return false;
  }

  passwordValidation(value: string): boolean {
    this.pass = value;
    if (
      this.regEx.every((regex: RegExp) => regex.test(value)) &&
      value.length >= 8
    ) {
      return true;
    }
    return false;
  }

  dateValidation(value: string): boolean {
    if (!value) return false;
    const newDate = new Date();
    const selectDate = new Date(value);
    const difftime: number = Math.abs(newDate.getTime() - selectDate.getTime());
    const coreDate: number = difftime / (1000 * 60 * 60 * 24 * 364.5);
    if (coreDate < 4) return false;
    return true;
  }

  selectValidation(value: string): boolean {
    return true;
  }

  confirmPassValidation(value: string): boolean {
    if (value === this.pass) return true;
    return false;
  }

  textValidation(value: string): boolean {
    if (value.trim() && value.length < 64) return true;
    return false;
  }

  validationByStep(value: string): { [key: string]: boolean } {
    return {
      characters: value.length >= 8,
      uppercase: this.uppercaseValid(value),
      lowercase: this.lowercaseValid(value),
      number: this.numberValid(value),
      symbol: this.symbolValid(value),
    };
  }

  uppercaseValid = (value: string): boolean => /(?=.*[A-Z])/.test(value);

  lowercaseValid = (value: string): boolean => /(?=.*[a-z])/.test(value);

  numberValid = (value: string): boolean => /(?=.*[0-9])/.test(value);

  symbolValid = (value: string): boolean => /(?=.*[\W])/.test(value);
}

export const validationService: ValidationService = new ValidationService();
